/**
 * External Links
 *
 * External URL constants for the Plataforma Data Trust (PDT) and Portal de
 * Identidades Digitais (Portal ID) platforms, reused across the unified home
 * and the post-login destination resolution.
 *
 * @module home-v2/constants/links
 * @category Constants
 */

const PDT_BASE = import.meta.env.VITE_PDT_BASE_URL;
const PORTAL_ID_BASE = import.meta.env.VITE_PORTAL_ID_BASE_URL;

/**
 * Plataforma Data Trust (PDT) External Links
 *
 * Base URL is configured per environment via `VITE_PDT_BASE_URL`.
 *
 * @category Constants
 */
export const PDT_LINKS = {
  HOME: `${PDT_BASE}/home`,
  CONSULTA_INDIVIDUAL: `${PDT_BASE}/consulta`,
  CONSULTA_CPF: (cpf: string) =>
    `${PDT_BASE}/consulta/transacoes?document=${cpf}&page=1&resultsPerPage=10&timePeriod`,
  CONSULTA_TRANSACAO: (transactionId: string) =>
    `${PDT_BASE}/consulta/${transactionId}`,
  CONSULTA_LOTE: `${PDT_BASE}/lote`,
  MARCACAO_FRAUDE_LOTE: `${PDT_BASE}/marcacao-fraude/lote`,
  HISTORICO_CONSULTA_INDIVIDUAL: `${PDT_BASE}/consulta/transacoes?page=1&resultsPerPage=10&timePeriod=15days&orderByDesc=true`,
  HISTORICO_CONSULTA_LOTE: `${PDT_BASE}/lote/historico`,
  HISTORICO_CONTESTACOES: `${PDT_BASE}/consulta/contestacao?page=1&resultsPerPage=10&orderByDesc=true`,
  HISTORICO_BACKGROUND_CHECK: `${PDT_BASE}/background-check/historicos`,
  HISTORICO_MARCACAO_FRAUDE: `${PDT_BASE}/marcacao-fraude/historico?page=1&resultsPerPage=10&orderBy=createdAt&orderByDesc=true&timePeriod=month`,
  BACKGROUND_CHECK: `${PDT_BASE}/background-check`,
  DASHBOARD: `${PDT_BASE}/home/dashboard`,
  FAQ: 'https://clearsale.my.site.com/FAQ/s/?language=pt_BR',
  STATUS_SERVICO: 'https://status.clearsale.com.br/',
  DOCUMENTACAO_TECNICA:
    'https://devs.plataformadatatrust.serasaexperian.com.br/docs/introducao',
} as const;

/**
 * Portal de Identidades Digitais (Portal ID) External Links
 *
 * Base URLs are configured per environment via `VITE_PORTAL_ID_BASE_URL`.
 *
 * @category Constants
 */
export const PORTAL_ID_LINKS = {
  HOME: `${PORTAL_ID_BASE}/home`,
  // Inteligência de Dispositivos
  CONTEXTUAL_DASHBOARD: `${PORTAL_ID_BASE}/contextual/dashboard`,
  CONTEXTUAL_TRANSACTIONS: `${PORTAL_ID_BASE}/contextual/transactions`,
  CONTEXTUAL_SUSPICIOUS_DEVICES: `${PORTAL_ID_BASE}/contextual/suspiciousdevices`,
  CONTEXTUAL_ALLOWLIST: `${PORTAL_ID_BASE}/contextual/allowlist`,
  CONTEXTUAL_BLOCKLIST: `${PORTAL_ID_BASE}/contextual/blocklist`,
  CONTEXTUAL_BULK_BLOCKLIST: `${PORTAL_ID_BASE}/contextual/bulk-blocklist`,
  CONTEXTUAL_RULES: `${PORTAL_ID_BASE}/contextual/rules`,
  CONTEXTUAL_EXPORTS: `${PORTAL_ID_BASE}/contextual/exports`,
  // Verificação de documentos
  DOCUMENTS_TRANSACTIONS: `${PORTAL_ID_BASE}/documents-verification/transactions`,
  // MFA
  MFA_DASHBOARD: `${PORTAL_ID_BASE}/mfa/transactions`,
  // Biometria - Liveness
  BIOMETRY_LIVENESS_DASHBOARD: `${PORTAL_ID_BASE}/biometry/liveness/dashboard`,
  BIOMETRY_LIVENESS_TRANSACTIONS: `${PORTAL_ID_BASE}/biometry/liveness/transactions`,
  BIOMETRY_LIVENESS_FAILURES: `${PORTAL_ID_BASE}/biometry/liveness/transactions/failures`,
  BIOMETRY_LIVENESS_EXPORTS: `${PORTAL_ID_BASE}/biometry/liveness/exports`,
  // Biometria - Cadastral 1:N
  BIOMETRY_CADASTRAL_TRANSACTIONS: `${PORTAL_ID_BASE}/biometry/cadastral/transactions`,
  BIOMETRY_CADASTRAL_EXPORTS: `${PORTAL_ID_BASE}/biometry/cadastral/exports`,
  // Biometria - Transacional 1:1
  BIOMETRY_TRANSACTIONAL_TRANSACTIONS: `${PORTAL_ID_BASE}/biometry/transactional/transactions`,
  // Configurações
  SETTINGS: `${PORTAL_ID_BASE}/settings`,
  SETTINGS_CREDENTIALS: `${PORTAL_ID_BASE}/settings?tab=credentials`,
  SETTINGS_AUDITORIA: `${PORTAL_ID_BASE}/settings?tab=audit`,
  SETTINGS_FATURAMENTO: `${PORTAL_ID_BASE}/home?redirect=billing`,
} as const;
